import {Hook} from "../lib/Hook.js";

export class ThemeLightDarkService {

    themeChanged = new Hook();

    configuredThemeChanged = new Hook();

    _theme = 'light';

    _configuredTheme = 'auto';

    /**
     * @private
     */
    __osMatcher;

    /**
     * @type {SettingsRepository}
     * @private
     */
    __settings;

    /**
     *
     * @param {SettingsRepository} settings
     */
    constructor(settings) {
        this.__settings = settings;
        this.__osMatcher = window.matchMedia('(prefers-color-scheme: dark)');
        this.__osMatcher.addEventListener('change', (e) => {
            if (this._configuredTheme !== 'auto') {
                return;
            }
            this.setTheme(e.matches ? 'dark' : 'light');
        });
    }

    /**
     * @return {string}
     */
    getTheme() {
        return this._theme;
    }

    setTheme(theme) {
        if (theme !== 'light' && theme !== 'dark') {
            throw 'Invalid theme ' + theme;
        }
        if (theme === this._theme) {
            return;
        }
        this._theme = theme;
        this.themeChanged.fire(theme);
    }

    getConfiguredTheme() {
        return this._configuredTheme;
    }

    setConfiguredTheme(theme) {
        if (theme !== 'auto' && theme !== 'light' && theme !== 'dark') {
            throw 'Invalid theme ' + theme;
        }
        this._configuredTheme = theme;
        this.configuredThemeChanged.fire(theme);
        this.setTheme(theme === 'auto' ? this.getOsTheme() : theme);

    }

    getOsTheme() {
        return this.__osMatcher.matches ? 'dark' : 'light';
    }
}